export const CRONOS_TOKEN_LIST = {
  name: 'DmmExchange Token List',
  keywords: ['dmmexchange'],
  timestamp: '2020-12-12T00:00:00+00:00',
  tokens: [
    {
      chainId: 25,
      address: '0xc21223249CA28397B4B6541dfFaEcC539BfF0c59',
      symbol: 'USDC',
      name: 'USDC',
      decimals: 6,
    },
    {
      chainId: 25,
      address: '0x66e428c3f67a68878562e79A0234c1F83c208770',
      symbol: 'USDT',
      name: 'USDT',
      decimals: 6,
    },
    {
      chainId: 25,
      address: '0xF2001B145b43032AAF5Ee2884e456CCd805F677D',
      symbol: 'DAI',
      name: 'DAI',
      decimals: 18,
    },
    {
      chainId: 25,
      address: '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23',
      symbol: 'WCRO',
      name: 'Wrapped CRO',
      decimals: 18,
    },
    {
      chainId: 25,
      address: '0xe6801928061CDbE32AC5AD0634427E140EFd05F9',
      symbol: 'BIFI',
      name: 'Beefy.finance',
      decimals: 18,
    },
    {
      chainId: 25,
      address: '0xe44Fd7fCb2b1581822D0c862B68222998a0c299a',
      symbol: 'WETH',
      name: 'Wrapped Ether',
      decimals: 18,
    },
    {
      chainId: 25,
      address: '0xbED48612BC69fA1CaB67052b42a95FB30C1bcFee',
      symbol: 'SHIB',
      name: 'Shiba Inu',
      decimals: 18,
    },
    {
      chainId: 25,
      address: '0x2D03bECE6747ADC00E1a131BBA1469C15fD11e03',
      symbol: 'VVS',
      name: 'VVS Token',
      decimals: 18,
    },
    {
      chainId: 25,
      address: '0x062E66477Faf219F25D27dCED647BF57C3107d52',
      symbol: 'WBTC',
      name: 'Wrapped BTC',
      decimals: 8,
    },
    {
      chainId: 25,
      address: '0xadbd1231fb360047525BEdF962581F3eee7b49fe',
      symbol: 'CRONA',
      name: 'CronaSwap Token',
      decimals: 18,
      logoURI: 'https://app.cronaswap.org/images/tokens/0xadbd1231fb360047525BEdF962581F3eee7b49fe.svg',
    },
    {
      chainId: 25,
      address: '0x97749c9B61F878a880DfE312d2594AE07AEd7656',
      symbol: 'MMF',
      name: 'Mad Meerkat Finance',
      decimals: 18,
      logoURI: 'https://mm.finance//images/tokens/0x97749c9B61F878a880DfE312d2594AE07AEd7656.svg',
    },
    {
      chainId: 25,
      address: '0xB888d8Dd1733d72681b30c00ee76BDE93ae7aa93',
      symbol: 'ATOM',
      name: 'ATOM',
      decimals: 6,
    },
  ],
  version: {
    major: 0,
    minor: 0,
    patch: 0,
  },
}
